"use client";
import dynamic from "next/dynamic";
import React from "react";

const PostHogPageView = dynamic(() => import("./PostHogPageView"), {
  ssr: false,
});

const ClientPostHogPageView = () => {
  return <PostHogPageView />;
};

export default ClientPostHogPageView;
